import SubscriptionInfoView from '../../components/SubscriptionsInfo/Index'
import {
  connect
} from 'react-redux';
import {
  getSubStats,
  getSearchData,
  getAllSearchData
} from '../../actions/SubscriptionInfo';
const mapStateToProps = (state) => {
  const {
    subscription_total,
    search_results,
    all_search_results
  } = state.subscriptionInfo
  return {
    subscription_total,
    search_results,
    all_search_results,
    clients: state.app.clients,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getSubStats: () => {
      dispatch(getSubStats())
    },
    getSearchData: (obj) => {
      dispatch(getSearchData(obj))
    },
    getAllSearchData: (obj) => {
      dispatch(getAllSearchData(obj))
    }
  }
}

const SubscriptionInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionInfoView)

export default SubscriptionInfo




// WEBPACK FOOTER //
// ./src/containers/Subscriptionsinfo/SubscriptionsInfo.js